import { useEffect, useRef } from 'react'
import ReactSelect, { components as reactSelectComponents } from 'react-select'
import CreatableReactSelect from 'react-select/creatable'

const mergeIds = (...values) => [...new Set(values.flatMap(value => String(value || '').split(' ')).filter(Boolean))].join(' ')

const AccessibleInput = props => (
  <reactSelectComponents.Input
    {...props}
    aria-describedby={mergeIds(props.selectProps['aria-describedby'], props['aria-describedby']) || undefined}
  />
)

const AccessibleControl = props => {
  const controlRef = useRef(null)
  const consumerDescription = props.selectProps['aria-describedby']

  useEffect(() => {
    const input = controlRef.current?.querySelector('input')
    if (!input || !consumerDescription) return

    input.setAttribute('aria-describedby', mergeIds(consumerDescription, input.getAttribute('aria-describedby')))
  })

  const setControlRef = node => {
    controlRef.current = node
    if (typeof props.innerRef === 'function') props.innerRef(node)
    else if (props.innerRef) props.innerRef.current = node
  }

  return <reactSelectComponents.Control {...props} innerRef={setControlRef} />
}

export const Select = ({ classNamePrefix = 'ds-select', components, creatable = false, id, inputId = id, ...props }) => {
  const SelectComponent = creatable ? CreatableReactSelect : ReactSelect

  return (
    <SelectComponent
      classNamePrefix={classNamePrefix}
      components={{ Control: AccessibleControl, Input: AccessibleInput, ...components }}
      inputId={inputId}
      isSearchable={creatable}
      {...props}
    />
  )
}
